// extracted by mini-css-extract-plugin
export default {"container":"LadderTeamsDropdown_container_f8c48","label":"LadderTeamsDropdown_label_ba405"};